import { createAsyncThunk } from '@reduxjs/toolkit'

import { Delai, DelaiResponse } from '../../types/delaisTypes'
import {
  addDelaiApi,
  deleteDelaiApi,
  getDelaibyIdApi,
  getDelaiByActionIdApi,
  updateDelaiApi,
} from '../../api/delaiApi'
import { handleError } from '../../utils/errorHandler'

export const deleteDelai = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('delai/deleteDelai', async (DelaiId, thunkAPI) => {
  try {
    await deleteDelaiApi(DelaiId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addDelai = createAsyncThunk<Delai, Delai, { rejectValue: string }>(
  'delai/addDelai',
  async (newDelai, thunkAPI) => {
    try {
      const response = await addDelaiApi(newDelai)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getDelaibyId = createAsyncThunk<
  Delai,
  string,
  { rejectValue: string }
>('delai/getDelaibyId', async (DelaiId, thunkAPI) => {
  try {
    const response = await getDelaibyIdApi(DelaiId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateDelai = createAsyncThunk<
  Delai,
  { updatedDelai: Delai; _id: string },
  { rejectValue: string }
>('delai/updateDelai', async ({ updatedDelai, _id }, thunkAPI) => {
  try {
    const response = await updateDelaiApi(updatedDelai, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getDelaisByActionId = createAsyncThunk<
  DelaiResponse,
  string,
  { rejectValue: string }
>('delai/getDelaisByActionId', async (ActionId, thunkAPI) => {
  try {
    const response = await getDelaiByActionIdApi(ActionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
